import { TrophyFilled } from "@ant-design/icons";
import { useState } from "react";
import "./MenuDrawer.scss";
import { Button, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { RANKINGS_APP_BASEURL, TEAM_MANAGER_APP_BASEURL } from "~shared/constants.ts";
import logo from "/app-logo.png";

export const MenuDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  const productItems = [
    {
      key: "competition-admin-menu-item",
      href: "/",
      label: <Typography.Text>Competition Admin</Typography.Text>,
      icon: <TrophyFilled style={{ fontSize: "1.5rem", color: "#ff0000" }} />,
    },
    {
      key: "rankings-menu-item",
      href: RANKINGS_APP_BASEURL,
      label: <Typography.Text>Rankings</Typography.Text>,
      icon: <i style={{ color: "#00003C", fontSize: "1.5rem" }} className="fa-solid fa-star" />,
    },
    {
      key: "team-manger-menu-item",
      href: TEAM_MANAGER_APP_BASEURL,
      label: <Typography.Text>Team Manager</Typography.Text>,
      icon: <i style={{ color: "#00003C", fontSize: "1.5rem" }} className="fa-solid fa-users" />,
    },
  ];

  return (
    <div className={`drawer-wrapper ${isOpen ? "open" : "closed"}`}>
      <div className={`drawer-content header-content ${isOpen ? "open" : "closed"}`}>
        <div className="menu-button">
          <Button
            type="text"
            size="large"
            icon={isOpen ? <i className="fa-solid fa-xmark" /> : <i className="fa-solid fa-bars" />}
            onClick={toggleDrawer}
          />
        </div>
        <div className="drawer-app-logo">
          <div className="app-logo">
            <Link to="/">
              <img src={logo} alt="Logo" />
            </Link>
            <div className="logo-text">
              <FormattedMessage id="menu.available.modules" />
            </div>
          </div>
        </div>
      </div>
      <div className="drawer-body">
        <div className="drawer-content body-content">
          {productItems.map((item) => (
            <Typography.Link href={item.href} className="product-item" key={item.key}>
              <div className="product-item-icon">{item.icon}</div>
              <div className="product-item-text">{item.label}</div>
            </Typography.Link>
          ))}
        </div>
      </div>
    </div>
  );
};
